import {
  Checkbox,
  message,
  Select,
  PageHeader,
  Col,
  Row,
  Spin,
  Form as FormInitial,
  Upload,
  Popconfirm,
  Input,
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  cuentaMask,
  InputItem,
  TextAreaItem,
  ButtonItem,
  dineroDisabledMask,
  ErrorItem,
  SelectInsumosItem,
  SwitchItem,
  TabbedDynamicTable,
  DynamicCardForm,
  round2Decimals,
} from "../../../../Components/Items";
import AyudaConversion from "../../../../Components/AyudaConversion";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import { PlusOutlined, UploadOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'
import plantilla from "../../../../assets/plantillaSubirProductosProveedor.xlsx";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import CambiarTipoEntidadModal from "../../../../Components/CambiarTipoEntidadModal";
import MoverCuentasEntidadModal from "../../../../Components/MoverCuentasEntidadModal";
import ModalEditarPoliza from "../../../../Components/ModalEditarPoliza";
import ProgramacionEvaluacionesProveedor from "../../EvaluacionProveedores/Components/ProgramacionEvaluacionesProveedor";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

// Encabezados de la plantilla de productos del proveedor, en su columna original (A..E)
const ENCABEZADOS_PLANTILLA_PRODUCTOS = ["Código", "Descripción", "Unidad", "Compra Minima", "Precio"];
const ENCABEZADOS_OBLIGATORIOS_PLANTILLA = ["Descripción", "Precio"];

const normalizarEncabezado = (texto) =>
  String(texto ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

// Deja la fila de encabezados de la hoja con los nombres exactos que lee archivoVerificar:
// acepta "precio", "Codigo", "Precio " y similares, y si la celda de encabezado de una
// columna de la plantilla viene vacia (el proveedor suele borrar "Precio") la toma por su
// posicion. Modifica la hoja y regresa los avisos para el usuario y los obligatorios que faltan.
const normalizarEncabezadosPlantilla = (hoja) => {
  const avisos = [];
  if (!hoja || !hoja["!ref"]) {
    return { avisos, faltantes: ENCABEZADOS_OBLIGATORIOS_PLANTILLA };
  }
  const rango = XLSX.utils.decode_range(hoja["!ref"]);
  const fila = rango.s.r;
  const valorCelda = (c) => {
    const celda = hoja[XLSX.utils.encode_cell({ r: fila, c })];
    return celda && celda.v !== undefined && celda.v !== null ? String(celda.v) : "";
  };
  const presentes = new Set();

  for (let c = rango.s.c; c <= rango.e.c; c++) {
    const valor = valorCelda(c);
    const canonico = ENCABEZADOS_PLANTILLA_PRODUCTOS.find(
      (encabezado) => normalizarEncabezado(encabezado) === normalizarEncabezado(valor),
    );
    if (canonico && !presentes.has(canonico)) {
      presentes.add(canonico);
      if (valor !== canonico) {
        hoja[XLSX.utils.encode_cell({ r: fila, c })] = { t: "s", v: canonico };
      }
    }
  }

  ENCABEZADOS_PLANTILLA_PRODUCTOS.forEach((canonico, c) => {
    if (presentes.has(canonico) || c < rango.s.c || c > rango.e.c) return;
    if (valorCelda(c).trim() === "") {
      hoja[XLSX.utils.encode_cell({ r: fila, c })] = { t: "s", v: canonico };
      presentes.add(canonico);
      avisos.push(`La columna ${XLSX.utils.encode_col(c)} no tiene encabezado, se tomó como "${canonico}"`);
    }
  });

  return {
    avisos,
    faltantes: ENCABEZADOS_OBLIGATORIOS_PLANTILLA.filter((encabezado) => !presentes.has(encabezado)),
  };
};

class EditarProveedor extends Component {
  formRef = React.createRef();
  // Insumos emparejados de la plantilla de productos, por _id, para el insumoPreCargado
  // de cada renglón. Fuera del state a propósito: se llena justo antes del setFieldsValue
  // que re-renderiza la tabla, y un setState re-renderizaría la página completa.
  insumosPreCargadosSubir = new Map();
  state = {
    loading: false,
    todasMonedas: null,
    objetoMonedas: null,
    todasPaises: null,
    objetoPaises: null,
    todasEstados: null,
    objetoEstados: null,
    todasMunicipios: null,
    objetoMunicipios: null,
    todasColonias: null,
    objetoColonias: null,
    todasTipoDeProveedor: null,
    objetoTipoDeProveedor: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    todasBancosSat: null,
    objetoBancosSat: null,
    todasTiposDeOperacion: null,
    objetoTiposDeOperacion: null,
    todasTiposDeTerceros: null,
    objetoTiposDeTerceros: null,
    modalAgregarCuentaContable: false,
    modalAgregarTipoDeProveedor: false,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    todasInsumos: [],
    objetoInsumos: null,
    utilizado: false,
    id: this.props.location.state.id,
    dataInicial: null,
    insumosRelacionados: [],
    loadingSubir: false,
    factorajeFinancieroCXC: false,
    // Archivos
    archivosProveedor: [],
    filePreviewVisible: false,
    currentPreviewFile: null,
    maximoArchivos: 3,
    objetoMunicipiosDropshipping: null,
    objetoColoniasDropshipping: null,
    todasColoniasDropshipping: null,
    credencialesConfiguradas: false,
    todasPaisesResidencia: null,
    objetoPaisesResidencia: null,
    modalCambiarTipo: false,
    modalMoverCuentas: false,
    polizaReclasificacionId: null,
  };
  atras() {
    this.props.history.goBack();
  }
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proveedores/selectDatosParaProveedor",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            factorajeFinancieroCXC: res.data.factorajeFinancieroCXC,
            todasBancosSat: res.data.bancosSat,
            todasTipoDeProveedor: res.data.tipoDeProveedores,
            todasCuentaContable: res.data.cuentasContables,
            todasMonedas: res.data.monedas,
            todasPaises: res.data.paises,
            todasEstados: res.data.estados,
            todasRegimenFiscal: res.data.regimenesFiscales,
            todasRetenciones: res.data.retenciones,
            maximoArchivos: res.data.maximoArchivos,
            todasFormasDePago: res.data.formasDePago,
            objetoUsosDeCFDI: (res.data.usosDeCFDI || []).map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_UsoCFDI + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoFormasDePago: (res.data.formasDePago || []).map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_FormaPago + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoCuentaContable: res.data.cuentasContables.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5,
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
            objetoTipoDeProveedor: res.data.tipoDeProveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoBancosSat: res.data.bancosSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.clave + " - " + value.nombreCorto}
                </Option>
              );
            }),
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            objetoRetenciones: res.data.retenciones.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasPaisesResidencia: res.data.paisesResidencia,
            objetoPaisesResidencia: res.data.paisesResidencia?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proveedores/datosProveedor",
        { empresaId: this.props.empresaId, proveedorId: this.state.id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del proveedor");
        } else {
          if (res.data.utilizado) {
            message.info(
              "No se puede modificar toda la informacion ya que el proveedor ya fue utilizado",
            );
          }
          if (res.data.estadoId) {
            this.onChangeEstado(res.data.estadoId);
          }
          if (res.data.municipioId) {
            this.onChangeMunicipio(res.data.municipioId);
          }

          if (res.data?.direccionDropshipping) {
            if (res.data?.direccionDropshipping.estadoId) {
              this.onChangeEstadoDropshipping(res.data?.direccionDropshipping.estadoId, true);
            }
            if (res.data?.direccionDropshipping.municipioId) {
              this.onChangeMunicipioDropshipping(res.data?.direccionDropshipping.municipioId, true);
            }
          }

          if (res.data.tipoProveedorId) {
            const tipoDeProveedor = this.state.todasTipoDeProveedor.find(
              (valueTodos) =>
                valueTodos._id.toString() ===
                res.data.tipoProveedorId.toString(),
            );
            if (tipoDeProveedor.generarCuentasAutomatico) {
              this.formRef.current.setFieldsValue({
                ...res.data,
                cuentaProveedorId: res.data.cuentaProveedorId,
                cuentaAnticipoId: res.data.cuentaAnticipoId,
                cuentaFonGarId: res.data.cuentaFonGarId,
                cuentaDeudorId: res.data.cuentaDeudorId,
              });
            } else {
              this.formRef.current.setFieldsValue({
                ...res.data,
                cuentaProveedorId: tipoDeProveedor.cuentaProveedorId,
                cuentaAnticipoId: tipoDeProveedor.cuentaAnticipoId,
                cuentaFonGarId: tipoDeProveedor.cuentaFonGarId,
                cuentaDeudorId: tipoDeProveedor.cuentaDeudorId,
              });
            }
          } else {
            this.formRef.current.setFieldsValue({
              ...res.data,
            });
          }
          if (res.data.credencialesProveedor) {
            this.formRef.current.setFieldsValue({
              credencialesProveedor: {
                tipo: res.data.credencialesProveedor.tipo,
                usuario: res.data.credencialesProveedor.usuario,
              },
            });
          }
          this.setState({
            utilizado: res.data.utilizado,
            dataInicial: res.data,
            insumosRelacionados: res.data.insumosRelacionados,
            archivosProveedor: res.data.archivos || [],
            credencialesConfiguradas: !!res.data.credencialesProveedor,
          });
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });

    const archivosLimpios = this.state.archivosProveedor.map((archivo) => {
      if (archivo.url && archivo.url.startsWith("data:")) {
        return {
          name: archivo.name,
          url: archivo.url,
        };
      }

      if (archivo.cargadoDesdeBackend) {
        return { name: archivo.name, url: archivo.urlRelativa };
      }

      // Fallback por si acaso
      return archivo;
    });

    const { credencialesProveedor, ...resto } = values;

    axios
      .post(
        "proveedores/editarProveedor",
        {
          ...resto,
          empresaId: this.props.empresaId,
          proveedorId: this.state.id,
          archivos: archivosLimpios,
        },
        { headers: this.props.headersToken },
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          if (
            credencialesProveedor &&
            credencialesProveedor.tipo &&
            credencialesProveedor.usuario &&
            credencialesProveedor.password
          ) {
            try {
              await axios.post(
                "requisiciones/configurarCredencialesProveedor",
                {
                  empresaId: this.props.empresaId,
                  proveedorId: this.state.id,
                  tipo: credencialesProveedor.tipo,
                  usuario: credencialesProveedor.usuario,
                  password: credencialesProveedor.password,
                },
                { headers: this.props.headersToken },
              );
            } catch (err) {
              message.warning(
                "Proveedor editado, pero hubo un error guardando las credenciales del catálogo",
              );
            }
          }
          this.setState({ loading: false });
          message.success("Se ha editado un proveedor");
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          this.setState({ loading: false });
          message.error(res.data.message || "No se puede editar el proveedor");
        } else {
          this.setState({ loading: false });
          message.error("Hubo un error y el proveedor no se edito");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ cuentaContableId: codigo });
      }
    });
  }
  onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        municipioId: undefined,
        coloniaId: undefined,
      });
      this.setState({ objetoMunicipios: null, objetoColonias: null });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          this.setState({
            objetoMunicipios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  onChangeMunicipio(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({ coloniaId: undefined });
      this.setState({ objetoColonias: null });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          this.setState({
            objetoColonias: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
          });
        }
      });
  }
  onSearchColonia(value) {
    if (value.toString().length === 5) {
      axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          },
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            this.formRef.current.setFieldsValue({
              paisId: res.data.paisId,
              estadoId: res.data.estadoId,
              municipioId: res.data.municipioId,
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }
  onChangeTipoDeProveedor(value) {
    const tipoDeProveedor = this.state.todasTipoDeProveedor.find(
      (valueTodos) => valueTodos._id.toString() === value.toString(),
    );
    if (
      tipoDeProveedor.generarCuentasAutomatico &&
      value !== this.state.dataInicial?.tipoProveedorId
    ) {
      this.formRef.current.setFieldsValue({
        cuentaProveedorId:
          this.state.dataInicial?.cuentaProveedorId ||
          "Se generara al guardarlo",
        cuentaAnticipoId:
          this.state.dataInicial?.cuentaAnticipoId ||
          "Se generara al guardarlo",
        generarCuentaAnticipoId: false,
        cuentaFonGarId:
          this.state.dataInicial?.cuentaFonGarId || "Se generara al guardarlo",
        generarCuentaFonGarId: false,
        cuentaDeudorId:
          this.state.dataInicial?.cuentaDeudorId || "Se generara al guardarlo",
        generarCuentaDeudorId: false,
      });
    } else {
      this.formRef.current.setFieldsValue({
        cuentaProveedorId: tipoDeProveedor.cuentaProveedorId,
        cuentaAnticipoId: tipoDeProveedor.cuentaAnticipoId,
        generarCuentaAnticipoId: false,
        cuentaFonGarId: tipoDeProveedor.cuentaFonGarId,
        generarCuentaFonGarId: false,
        cuentaDeudorId: tipoDeProveedor.cuentaDeudorId,
        generarCuentaDeudorId: false,
      });
    }
  }
  onSelectColoniaId(coloniaId) {
    const colonia = this.formRef.current.getFieldValue("colonia");
    if (!colonia) {
      const nombreColonia = this.state.todasColonias.find(
        (todasColonia) => todasColonia._id.toString() === coloniaId.toString(),
      )?.nombre;
      this.formRef.current.setFieldsValue({
        colonia: nombreColonia,
      });
    }
  }
  onChangeRegimenFiscal(regimenFiscalId) {
    if (!this.state.utilizado) {
      const retencionAgregar = this.state.todasRetenciones.find(
        (todasRetenciones) =>
          todasRetenciones.regimenFiscalId.toString() ===
          regimenFiscalId.toString(),
      );
      const retenciones = this.formRef.current.getFieldValue("retenciones");
      if (retencionAgregar) {
        if (retenciones) {
          const findRetencion = retenciones.find(
            (todasRetencionesProv) =>
              todasRetencionesProv.retencionId.toString() ===
              retencionAgregar._id.toString(),
          );
          if (!findRetencion) {
            this.formRef.current.setFieldsValue({
              retenciones: [
                ...retenciones,
                { retencionId: retencionAgregar._id },
              ],
            });
          }
        } else {
          this.formRef.current.setFieldsValue({
            retenciones: [{ retencionId: retencionAgregar._id }],
          });
        }
      }
    }
  }

  async onChangeArchivo(e) {
    this.setState({ loadingSubir: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [
          {
            ...e.file,
            name: e.file.name,
            status: "uploading",
            response: "Cargando",
          },
        ],
        arhcivo: e.file,
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de excel");
      this.setState({ loadingSubir: false });
    }
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result);
      let workbook = XLSX.read(data, { type: "array" });

      const { avisos, faltantes } = normalizarEncabezadosPlantilla(
        workbook.Sheets[workbook.SheetNames[0]],
      );
      avisos.forEach((aviso) => message.warning(aviso));
      if (faltantes.length > 0) {
        message.error(
          `La plantilla no tiene ${faltantes.length > 1 ? "las columnas" : "la columna"} ${faltantes.map((f) => `"${f}"`).join(", ")} en la primera fila`,
        );
        this.setState({
          archivosExcel: [{ ...file, name: file.name, status: "error", response: "Faltan columnas" }],
          loadingSubir: false,
        });
        return;
      }

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName],
        );
        hojas.push({
          data: Xl_row_object,
          sheetName,
        });
      });
      let hoja1 = hojas[0].data;
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({
            archivosExcel: [{ ...file, name: file.name, status: "success" }],
          });
          this.consultarInsumoProveedor(dataReturn.objeto);
        } else {
          this.setState({
            archivosExcel: [
              {
                ...file,
                name: file.name,
                status: "success",
                response: "Con errores",
              },
            ],
            archivoError: dataReturn.archivoErrores,
          });
          message.error("Se han detectado " + dataReturn.errores + " errores");
          // message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loadingSubir: false });
      });
    };
  }

  async consultarInsumoProveedor(lista) {
    try {
      const responseListado = await axios.post(
        "insumos/selectInsumosRelacionadosConLista",
        { empresaId: this.props.empresaId, lista, proveedorId: this.state.id },
        {
          headers: this.props.headersToken,
        },
      );

      if (responseListado.data.success === 2) {
        this.insumosPreCargadosSubir = new Map(
          (responseListado.data.insumos || []).map((insumo) => [String(insumo._id), insumo]),
        );
        this.formRef.current.setFieldsValue({
          insumosSubir: responseListado.data.lista,
        });
      } else {
        message.warning("No se cargo correctamente la lista");
      }
    } catch (err) {
      message.warning("No se cargo correctamente la lista");
    }
  }

  async archivoVerificar(data) {
    let errores = 0;
    let filaErrores = 0;
    let mensaje = [];
    const archivoEditar = XLSX.utils.book_new();
    const arrayErrores = [];
    let objeto = [];
    await data.map((data, index) => {
      let mensajeErrores = null;
      let erroresFila = 0;
      let fila = data["__rowNum__"] + 1;
      let codigo = data["Código"] ? `${data["Código"]}`.trim() : undefined;
      let descripcion = data["Descripción"] ? data["Descripción"] : undefined;
      let unidadInformativa = data["Unidad"] ? data["Unidad"] : undefined;
      let precio = data["Precio"]
        ? Number(data["Precio"].toString().replace(/\$\s?|(,*)/g, ""))
        : undefined;
      let compraMin = data["Compra Minima"]
        ? Number(data["Compra Minima"].toString().replace(/\$\s?|(,*)/g, ""))
        : undefined;
      const checarQueSeaNumero = (valor, nombreCampo) => {
        if (valor !== "" && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1;
            erroresFila += 1;
            mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`);
            mensajeErrores = mensajeErrores
              ? mensajeErrores + `, ${nombreCampo} no es un numero`
              : `${nombreCampo} no es un numero`;
          }
        }
      };
      const queEste = (valor, nombreCampo) => {
        if (valor === "" || valor === undefined) {
          errores += 1;
          erroresFila += 1;
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`);
          mensajeErrores = mensajeErrores
            ? mensajeErrores + `, ${nombreCampo} esta vacio`
            : `${nombreCampo} esta vacio`;
        }
      };
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron =
        /^[A-Za-z0-9\n.  ,"'´`#:…°ºªáÁéÉíÍóÓúÚüÜñÑǪ@_/*+%&()!-]*$/;
        if (valor !== "" && valor !== undefined) {
          if (!patron.test(valor)) {
            for (let i = 0; i < valor.length; i++) {
              const char = valor[i];
              if (!patron.test(char)) {
                console.log(
                  `El carácter rechazado es: '${char}' en la posición ${i}`,
                );
              }
            }
            errores += 1;
            erroresFila += 1;
            mensaje.push(
              `${nombreCampo} fila: ${fila} no es un valor acceptado`,
            );
            mensajeErrores = mensajeErrores
              ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado`
              : `${nombreCampo} no es un valor acceptado`;
          }
        }
      };
      queSeaStringValido(codigo, "Código");
      queSeaStringValido(unidadInformativa, "Unidad");
      queEste(descripcion, "Descripción");
      queSeaStringValido(descripcion, "Descripción");
      queEste(precio, "Precio");
      checarQueSeaNumero(precio, "Precio");
      checarQueSeaNumero(compraMin, "Compra Minima");
      if (erroresFila === 0) {
        objeto.push({
          codigo,
          descripcion,
          unidadInformativa,
          compraMin,
          // A dos decimales, igual que lo guarda subirProductosProveedor: el Excel trae
          // precios calculados como 405.38520000000004
          precio: round2Decimals(precio),
        });
      } else {
        arrayErrores.push({
          Errores: mensajeErrores,
          "Fila archivo inicial": fila,
          ...data,
        });
        filaErrores += 1;
      }
      return null;
    });
    const hoja = XLSX.utils.json_to_sheet(arrayErrores);
    XLSX.utils.book_append_sheet(archivoEditar, hoja, "Hoja Errores");
    return {
      objeto: objeto,
      errores: errores,
      filaErrores,
      mensaje: mensaje,
      archivoErrores: archivoEditar,
    };
  }

  insumoPreCargadoSubir(name) {
    const insumoId = this.formRef.current?.getFieldValue(["insumosSubir", name, "insumoId"]);
    return insumoId ? this.insumosPreCargadosSubir.get(String(insumoId)) : undefined;
  }

  async subirProductos() {
    const lista = this.formRef.current.getFieldValue("insumosSubir");

    if (lista && lista?.length > 0) {
      this.setState({ loadingSubir: true });

      try {
        const responseListado = await axios.post(
          "insumos/subirProductosProveedor",
          {
            empresaId: this.props.empresaId,
            lista,
            proveedorId: this.state.id,
          },
          {
            headers: this.props.headersToken,
          },
        );

        if (responseListado.data.success === 2) {
          this.setState({ loadingSubir: false });
          message.success(
            "Se han editado " +
              responseListado.data.cantidadInsumos +
              " productos",
          );
        } else {
          this.setState({ loadingSubir: false });
          message.warning("No se edito correctamente los insumos");
        }
      } catch (err) {
        message.warning("No se edito correctamente los insumos");
      }
    } else {
      return message.warning("Necesita haber productos para subir");
    }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf); //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    };
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onRemoveFile(e) {
    let index = this.state.archivosProveedor.indexOf(e);
    let nuevoArray = this.state.archivosProveedor;
    nuevoArray.splice(index, 1);
    this.setState({ archivosProveedor: nuevoArray });
  }
  async customRequestArchivos(e) {
    const file = e.file;
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isLt5M) {
      message.error(`${file.name} supera los 5 MB`);
      e.onError("Archivo demasiado grande");
      return;
    }
    const base64 = await getBase64(file);

    const nuevoArchivo = {
      uid: file.uid,
      name: file.name,
      status: "done",
      url: base64,
      originFileObj: file,
    };

    this.setState({
      archivosProveedor: [...this.state.archivosProveedor, nuevoArchivo],
    });

    e.onSuccess("ok");
  }
  beforeUploadArchivos = (file, fileList) => {
    const { archivosProveedor, maximoArchivos } = this.state;
    const totalProyectado = archivosProveedor.length + fileList.length;

    if (totalProyectado > maximoArchivos) {
      if (file === fileList[0]) {
        message.error(
          `Con esta selección, superarías el límite de ${maximoArchivos} archivos.`,
        );
      }
      return Upload.LIST_IGNORE;
    }

    const isLt25M = file.size / 1024 / 1024 < 25;
    if (!isLt25M) {
      message.error(`${file.name} excede el tamaño máximo de 25MB`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };
  handlePreview = (file) => {
    this.setState({
      currentPreviewFile: file,
      filePreviewVisible: true,
    });
  };

  handleCloseFilePreview = () => {
    this.setState({
      filePreviewVisible: false,
      currentPreviewFile: null,
    });
  };

  onChangeEstadoDropshipping(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionDropshipping: {
          ...this.formRef.current.getFieldValue("direccionDropshipping"),
          municipioId: undefined,
          coloniaId: undefined,
        },
      });
      this.setState({
        objetoMunicipiosDropshipping: null,
        objetoColoniasDropshipping: null,
      });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoMunicipiosDropshipping: res.data.map((v) => (
              <Option value={v._id} key={v._id}>
                {v.nombre}
              </Option>
            )),
          });
        }
      });
  }

  onChangeMunicipioDropshipping(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionDropshipping: {
          ...this.formRef.current.getFieldValue("direccionDropshipping"),
          coloniaId: undefined,
        },
      });
      this.setState({ objetoColoniasDropshipping: null });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasColoniasDropshipping: res.data,
            objetoColoniasDropshipping: res.data.map((v) => (
              <Option value={v._id} key={v._id}>
                {v.cp + " - " + v.nombre}
              </Option>
            )),
          });
        }
      });
  }

  onSearchColoniaDropshipping(value) {
    if (value.toString().length === 5) {
      axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.formRef.current.setFieldsValue({
              direccionDropshipping: {
                paisId: res.data.paisId,
                estadoId: res.data.estadoId,
                municipioId: res.data.municipioId,
                coloniaId:
                  res.data.colonias && res.data.colonias.length > 0
                    ? res.data.colonias[0]._id
                    : undefined,
              },
            });
            this.onChangeEstadoDropshipping(res.data.estadoId, true);
            this.onChangeMunicipioDropshipping(res.data.municipioId, true);
          } else {
            message.info("No se encontró el código postal");
          }
        });
    }
  }

  onSelectColoniaIdDropshipping(coloniaId) {
    const direccion = this.formRef.current.getFieldValue(
      "direccionDropshipping",
    );
    if (!direccion?.colonia) {
      const nombreColonia = this.state.todasColoniasDropshipping.find(
        (c) => c._id.toString() === coloniaId.toString(),
      )?.nombre;
      this.formRef.current.setFieldsValue({
        direccionDropshipping: { ...direccion, colonia: nombreColonia },
      });
    }
  }

  render() {
    const { filePreviewVisible, currentPreviewFile } = this.state;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Proveedor"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarProveedor"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  cyan
                  style={{ display: "block", margin: "0 0 0 auto", minWidth: 120, height: 30 }}
                >
                  Guardar Proveedor
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <TabbedDynamicTable
                
                defaultActiveKey="1"
                tabs={[
                  {
                    key: '1',
                    label: 'General',
                    forceRender: true,
                    customContent: (
                      <>
                        <Row gutter={16}>
                          <Col span={12} xs={24} sm={24} lg={13} xl={13}>
                            <DynamicCardForm title={<span>Datos Generales</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    name="codigo"
                                    label="Codigo"
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                  >
                                    <InputItem disabled placeholder="Codigo" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="clave"
                                    label="Clave"
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                    pattern
                                  >
                                    <InputItem placeholder="Clave" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="RFC"
                                    name="rfc"
                                    required
                                    margin
                                    rfc
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 16 }}
                                  >
                                    <InputItem placeholder="RFC" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    name="persona"
                                    label="P. Moral"
                                    valuePropName="checked"
                                    initialValue={false}
                                    margin
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 12 }}
                                  >
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            label="CURP"
                                            margin
                                            pattern
                                            max={20}
                                            name="curp"
                                            labelCol={{ span: 10 }}
                                            wrapperCol={{ span: 18 }}
                                          >
                                            <InputItem placeholder="Curp" />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  if (getFieldValue("persona")) {
                                    return (
                                      <FormItem
                                        label="Razon Social"
                                        margin
                                        pattern
                                        required
                                        name="razonSocial"
                                        labelCol={{ span: 5}}
                                        wrapperCol={{ span: 18 }}
                                      >
                                        <InputItem placeholder="Razon Social" />
                                      </FormItem>
                                    );
                                  }
                                }}
                              </FormItem>
                              <Row>
                                <Col span={10}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            label="Nombre"
                                            margin
                                            pattern
                                            required
                                            name="nombre"
                                            labelCol={{ span: 12 }}
                                            wrapperCol={{ span: 12 }}
                                          >
                                            <InputItem
                                              placeholder="Nombre"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            required
                                            name="apellidoPaterno"
                                            labelCol={{ span: 0 }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem
                                              placeholder="Appelido Paterno"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                                <Col span={7}>
                                  <FormItem shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      if (!getFieldValue("persona")) {
                                        return (
                                          <FormItem
                                            margin
                                            pattern
                                            required
                                            name="apellidoMaterno"
                                            labelCol={{ span: 0 }}
                                            wrapperCol={{ span: 24 }}
                                          >
                                            <InputItem
                                              placeholder="Appellido Materno"
                                              width="98%"
                                            />
                                          </FormItem>
                                        );
                                      }
                                    }}
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    margin
                                    pattern
                                    max={200}
                                    name="nombreComercial"
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Nombre Comercial</span>}
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ span: 18 }}
                                  >
                                    <InputItem placeholder="Nombre Comercial" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    shouldUpdate={(prev, cur) => prev.rfc !== cur.rfc}
                                    noStyle
                                  >
                                    {({ getFieldValue }) =>
                                      getFieldValue("rfc") === "XEXX010101000" && (
                                        <Row gutter={[16, 0]}>
                                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                            <FormItem
                                              label="ID Trib."
                                              name="registroIDTributario"
                                              margin
                                              pattern
                                              labelCol={{ span: 5 }}
                                              wrapperCol={{ span: 18 }}
                                              tooltip="Número de Registro de Identificación Tributaria del extranjero"
                                            >
                                              <InputItem placeholder="Ej: VAT-DE123456789" />
                                            </FormItem>
                                          </Col>
                                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                            <FormItem
                                              label="Residencia Fiscal"
                                              name="paisResidenciaId"
                                              margin
                                              labelCol={{ span: 5 }}
                                              wrapperCol={{ span: 18 }}
                                            >
                                              <SelectItem placeholder="Residencia Fiscal">
                                                {this.state.objetoPaisesResidencia}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      )
                                    }
                                  </FormItem>
                                </Col>
                              </Row>

                            </DynamicCardForm>

                            <DynamicCardForm title={<span> Datos del Contacto General </span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="Celular"
                                    name="celular"
                                    number
                                    margin
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} 
                                  >
                                    <InputNumberItem placeholder="Celular" celular />
                                  </FormItem>
                                  <FormItem
                                    label="Telefono"
                                    name="telefono"
                                    number
                                    margin
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} 
                                  >
                                    <InputNumberItem placeholder="Telefono" celular />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    label="Correo"
                                    name="correo"
                                    pattern
                                    max={200}
                                    email
                                    margin
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Correo" />
                                  </FormItem>
                                  <FormItem
                                    label="Correos Adicionales"
                                    margin
                                    tooltip="Se precargan al enviar una orden de compra por correo. Los correos que se usen al enviar se agregan aqui solos."
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }}
                                  >
                                    <FormInitial.List name="correosAdicionales">
                                      {(fields, { add, remove }) => (
                                        <>
                                          {fields.map(({ name }, arrayKey) => (
                                            <Row key={arrayKey} gutter={8} align="middle">
                                              <Col span={20}>
                                                <FormItem
                                                  name={[name, "correo"]}
                                                  fieldKey={[arrayKey, "correo"]}
                                                  required
                                                  margin
                                                  noStyle
                                                  email
                                                  pattern
                                                >
                                                  <InputItem placeholder="Correo" />
                                                </FormItem>
                                              </Col>
                                              <Col span={4}>
                                                <div style={{ textAlign: 'center' }}>
                                                  <ButtonItem
                                                    rojo2
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => remove(name)}
                                                    lessTime
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                          <div style={{ marginTop: 5 }}>
                                            <ButtonItem
                                              blanco={true}
                                              icon={<PlusOutlined />}
                                              onClick={() => add()}
                                              lessTime
                                            >
                                              Agregar correo
                                            </ButtonItem>
                                          </div>
                                        </>
                                      )}
                                    </FormInitial.List>
                                  </FormItem>
                                  <FormItem
                                    label="Pagina Web"
                                    name="paginaWeb"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} 
                                  >
                                    <InputItem placeholder="Pagina Web" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    name="observaciones"
                                    label="Observaciones"
                                    margin
                                    pattern
                                    labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}
                                  >
                                    <TextAreaItem placeholder="Observaciones" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span> Contacto del Proveedor</span>}>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Nombre"
                                    name="nombreContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18}, xl: { span: 18}, xs: { span: 18 } }} 
                                  >
                                    <InputItem placeholder="Nombre de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Teléfono"
                                    name="telefonoContacto"
                                    number
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}

                                  >
                                    <InputNumberItem
                                      placeholder="Telefono de Contacto"
                                      celular
                                    />
                                  </FormItem>
                                </Col>
                                <Col span={24}>
                                  <FormItem
                                    label="Correo"
                                    name="correoContacto"
                                    pattern
                                    max={200}
                                    email
                                    margin
                                     labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18 }, xl: { span: 18 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Correo de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem                           
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Personas pedidos</span>}
                                    name="personasPedidos"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18}, xl: { span: 18}, xs: { span: 18 } }} 
                                  >
                                    <InputItem placeholder="Personas que atienden pedidos" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Jefe de Contacto</span>}
                                    name="jefeContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5 }}
                                    wrapperCol={{ lg: { span: 18}, xl: { span: 18}, xs: { span: 18 } }} 
                                  >
                                    <InputItem placeholder="Jefe de Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label={<span style={{ whiteSpace: 'normal', wordBreak: 'break-word', display: 'inline-block', lineHeight: 1.2 }}>Puesto Jefe Contacto</span>}
                                    name="puestoJefeContacto"
                                    pattern
                                    max={200}
                                    margin
                                    labelCol={{ span: 5}}
                                    wrapperCol={{ lg: { span: 18}, xl: { span: 18}, xs: { span: 18 } }} 
                                  >
                                    <InputItem placeholder="Pueso del Jefe del Contacto" />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>
                          </Col>

                          <Col span={12} xs={24} sm={24} lg={11} xl={11}>
                            <DynamicCardForm title={<span>Crédito y Bancos</span>}>
                              <Row>
                                <Col span={12}>
                                  <FormItem
                                    label="Dias crédito"
                                    name="diasCredito"
                                    numberCero
                                    margin
                                    labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 10 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} 
                                  >
                                    <InputNumberItem placeholder="Dias de Credito" />
                                  </FormItem>
                                </Col>
                                <Col span={12}>
                                  <FormItem
                                    label="Crédito"
                                    name="limiteCredito"
                                    numberCero
                                    margin
                                    labelCol={{ lg: { span: 10}, xl: { span: 10}, xs: { span: 4 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }} 
                                  >
                                    <InputNumberItem
                                      dinero
                                      placeholder="Limite de credito"
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                              {this.props.escuela && (
                                <Row>
                                  <Col span={12}>
                                    <FormItem
                                      label="Desc. Predet."
                                      name="descuentoPredeterminado"
                                      numberCero
                                      margin
                                      tooltip="Se precarga como Desc. Prov. en cada renglón de órdenes de compra y facturas de proveedor. En cada operación se le puede sumar un descuento adicional (en cascada)."
                                      labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 10 } }} wrapperCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 18 } }}
                                    >
                                      <InputNumberItem porcentaje max={100} placeholder="Descuento" />
                                    </FormItem>
                                  </Col>
                                </Row>
                              )}
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Moneda"
                                    name="monedaId"
                                    required
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }} 
                                  >
                                    <SelectItem placeholder="Tipo de Moneda">
                                      {this.state.objetoMonedas}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Banco"
                                    name="bancoSatId"
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }} 
                                  >
                                    <SelectItem placeholder="Banco">
                                      {this.state.objetoBancosSat}
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="Cuenta"
                                    name="cuentaBanco"
                                    number
                                    max={20}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Cuenta de Banco" />
                                  </FormItem>
                                </Col>
                                <Col span={24}>
                                  <FormItem
                                    label="Cuenta Clabe"
                                    name="cuentaClabe"
                                    number
                                    max={18}
                                    min={18}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Cuenta Clabe" />
                                  </FormItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    name="pagoElectronico"
                                    label="Pago electrónico"
                                    valuePropName="checked"
                                    initialValue={true}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <Checkbox />
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <DynamicCardForm title={<span>Contabilidad</span>}>
                              <FormItem
                                name="proveedorExtranjero"
                                label="P. Extranjero"
                                valuePropName="checked"
                                initialValue={false}
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                              >
                                <SwitchItem disabled={this.state.utilizado} />
                              </FormItem>
                              <FormItem
                                name="regimenFiscalId"
                                label="R. Fiscal"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  onChange={this.onChangeRegimenFiscal.bind(this)}
                                  placeholder="Regimen Fiscal"
                                >
                                  {this.state.objetoRegimenFiscal}
                                </SelectItem>
                              </FormItem>
                              <FormItem
                                name="usoDeCfdiId"
                                label="Uso de CFDI"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                              >
                                <SelectItem placeholder="Uso de CFDI" allowClear>
                                  {this.state.objetoUsosDeCFDI}
                                </SelectItem>
                              </FormItem>
                              <FormItem
                                name="metodoPago"
                                label="Método de Pago"
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  placeholder="Método de Pago"
                                  allowClear
                                  onChange={() => this.formRef.current.setFieldsValue({ formaDePagoId: undefined })}
                                >
                                  <Option value={1}>PUE - Pago en Una sola Exhibición</Option>
                                  <Option value={2}>PPD - Pago en Parcialidades o Diferido</Option>
                                </SelectItem>
                              </FormItem>
                              <FormItem noStyle shouldUpdate={(prev, curr) => prev.metodoPago !== curr.metodoPago}>
                                {({ getFieldValue }) => {
                                  const metodoPago = getFieldValue("metodoPago");
                                  const todas = this.state.todasFormasDePago || [];
                                  let filtradas = todas;
                                  if (metodoPago === 2) filtradas = todas.filter(v => v.c_FormaPago === 99);
                                  else if (metodoPago === 1) filtradas = todas.filter(v => v.c_FormaPago !== 99);
                                  return (
                                    <FormItem
                                      name="formaDePagoId"
                                      label="Forma de Pago"
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                                    >
                                      <SelectItem placeholder="Forma de Pago" allowClear>
                                        {filtradas.map(v => (
                                          <Option value={v._id} key={v._id}>
                                            {v.c_FormaPago + " - " + v.descripcion}
                                          </Option>
                                        ))}
                                      </SelectItem>
                                    </FormItem>
                                  );
                                }}
                              </FormItem>
                              <FormItem
                                name="insumoGastoId"
                                label="Gasto"
                                tooltip="Insumo al que pertenecen por defecto las facturas de este proveedor. Solo prellena la captura rapida de gasto; se puede cambiar al capturar."
                                margin
                                labelCol={{ span: 6 }}
                                wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                              >
                                <SelectInsumosItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  tiposInsumos="compra"
                                  width="100%"
                                  dropdownMatchSelectWidth={600}
                                  placeholder="Gasto predeterminado"
                                  allowClear
                                />
                              </FormItem>
                              <FormItem
                                 label="T. Proveedor"
                                 margin
                                 name="tipoProveedorId"
                                 required
                                 labelCol={{ span: 6 }}
                                 wrapperCol={{ lg: { span: 17}, xl: { span: 17}, xs: { span: 18 } }}
                              >
                                <SelectItem
                                  // El proveedor que YA tiene tipo cambia solo por el
                                  // modal: el select de aqui va por editarProveedor, que
                                  // no reasigna las cuentas ya generadas (deja la
                                  // subcuenta colgada del arbol del tipo anterior) ni
                                  // genera la poliza de reclasificacion. Si no tiene tipo
                                  // todavia (importados) se sigue pudiendo asignar aqui.
                                  disabled={!!this.state.dataInicial?.tipoProveedorId}
                                  placeholder="Tipo de Proveedor"
                                  onChange={this.onChangeTipoDeProveedor.bind(this)}
                                >
                                  {this.state.objetoTipoDeProveedor}
                                </SelectItem>
                              </FormItem>
                              {this.state.dataInicial?.tipoProveedorId ? (
                                <div style={{ textAlign: "right", marginBottom: 8 }}>
                                  <ButtonItem
                                    type="primary"
                                    blanco
                                    size="small"
                                    onClick={() => this.setState({ modalCambiarTipo: true })}
                                  >
                                    Cambiar tipo de proveedor
                                  </ButtonItem>
                                </div>
                              ) : null}
                              <Row>
                                <Col span={24}>
                                  <FormItem
                                    label="T. Operación DIOT"
                                    name="tipoOperacion"
                                    required
                                    margin
                                    initialValue={3}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <SelectItem placeholder="Tipo de Operación DIOT">
                                      <Option value={1}>
                                        03 - Prestacion de servicios
                                      </Option>
                                      <Option value={2}>
                                        06 - Arrendamiento de inmuebles
                                      </Option>
                                      <Option value={3}>85 - Otros</Option>
                                      <Option value={4}>NA - No asignados</Option>
                                      <Option value={5}>02 - Enajenación de bienes</Option>
                                      <Option value={6}>07 - Importación de bienes o servicios</Option>
                                      <Option value={7}>08 - Importación por transferencia virtual</Option>
                                      <Option value={8}>87 - Operaciones globales</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                                <Col span={24}>
                                  <FormItem
                                    label="T. Tercero DIOT"
                                    name="tipoTercero"
                                    required
                                    margin
                                    initialValue={1}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 10 }}
                                  >
                                    <SelectItem placeholder="Tipo de Tercero DIOT">
                                      <Option value={1}>
                                        04 - Proveedor Nacional
                                      </Option>
                                      <Option value={2}>
                                        05 - Proveedor Extranjero
                                      </Option>
                                      <Option value={3}>15 - Proveedor Global</Option>
                                    </SelectItem>
                                  </FormItem>
                                </Col>
                              </Row>
                            </DynamicCardForm>

                            <FormInitial.List name="retenciones">
                              {(fields, { add, remove }) => {
                                if (fields.length === 0 && this.state.utilizado) {
                                  return null;
                                }
                                return (
                                  <DynamicCardForm title={<span>Retenciones</span>}>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "retencionId"]}
                                            fieldKey={[arrayKey, "retencionId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectItem
                                              disabled={this.state.utilizado}
                                              width="100%"
                                              placeholder="Retención"
                                            >
                                              {this.state.objetoRetenciones}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            {!this.state.utilizado && (
                                              <ButtonItem
                                                type="dashed"
                                                rojo2
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(name)}
                                              />
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 12 }}>
                                      {!this.state.utilizado && (
                                        <ButtonItem
                                          type="primary"
                                          cyan
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                        >
                                          Agregar
                                        </ButtonItem>
                                      )}
                                    </div>
                                  </DynamicCardForm>
                                );
                              }}
                            </FormInitial.List>

                            <DynamicCardForm title={<span>Proyectos</span>}>
                              <FormInitial.List name="proyectos">
                                {(fields, { add, remove }) => (
                                  <>
                                    {fields.map(({ name }, arrayKey) => (
                                      <Row key={arrayKey} gutter={8} align="middle">
                                        <Col span={22}>
                                          <FormItem
                                            name={[name, "proyectoId"]}
                                            fieldKey={[arrayKey, "proyectoId"]}
                                            required
                                            margin
                                            noStyle
                                          >
                                            <SelectProyectosItem
                                              empresaId={this.props.empresaId}
                                              headersToken={this.props.headersToken}
                                              width="100%"
                                              placeholder="Proyecto"
                                            />
                                          </FormItem>
                                        </Col>
                                        <Col span={2}>
                                          <div style={{ textAlign: "center" }}>
                                            <ButtonItem
                                              type="dashed"
                                              rojo2
                                              icon={<DeleteOutlined />}
                                              onClick={() => remove(name)}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    ))}
                                    <div style={{ textAlign: "center", marginTop: 12 }}>
                                      <ButtonItem
                                        type="primary"
                                        cyan
                                        onClick={() => add()}
                                        icon={<PlusOutlined />}
                                      >
                                        Agregar
                                      </ButtonItem>
                                    </div>
                                  </>
                                )}
                              </FormInitial.List>
                            </DynamicCardForm>
                          </Col>
                        </Row>

                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Cuentas Contables</span>}>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const tipoDeProveedorId =
                                    getFieldValue("tipoProveedorId");
                                  const tipoDeProveedor = tipoDeProveedorId
                                    ? this.state.todasTipoDeProveedor.find(
                                        (valueTodos) =>
                                          valueTodos._id.toString() ===
                                          tipoDeProveedorId.toString(),
                                      )
                                    : null;
                                  return (
                                    <Row gutter={16}>
                                      <Col span={24}>
                                        <Row>
                                          <Col span={22}>
                                            <FormItem
                                              label="Cuenta Proveedor"
                                              name="cuentaProveedorId"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Proveedor"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              name="cuentaAnticipoId"
                                              label="Cuenta Anticipo"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Anticipo"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaAnticipoId"
                                              valuePropName="checked"
                                            >
                                              <Checkbox
                                                disabled={
                                                  !tipoDeProveedor?.generarCuentasAutomatico ||
                                                  !!this.state?.dataInicial
                                                    ?.cuentaAnticipoId
                                                }
                                              ></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col span={24}>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              label="Cuenta Fon. Gar."
                                              tooltip="Selecciona primero un tipo de proveedor"
                                              margin
                                              name="cuentaFonGarId"
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Fondo de Gararantia"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaFonGarId"
                                              valuePropName="checked"
                                            >
                                              <Checkbox
                                                disabled={
                                                  !tipoDeProveedor?.generarCuentasAutomatico ||
                                                  !!this.state?.dataInicial
                                                    ?.cuentaFonGarId
                                                }
                                              ></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                        <Row align="middle">
                                          <Col span={22}>
                                            <FormItem
                                              label="Cuenta Deudor"
                                              name="cuentaDeudorId"
                                              margin
                                              labelCol={{ span: 7 }}
                                              wrapperCol={{ span: 17 }}
                                              tooltip="Selecciona primero un tipo de proveedor"
                                            >
                                              <SelectItem
                                                disabled
                                                placeholder="Cuenta Deudor"
                                                width="100%"
                                              >
                                                {this.state.objetoCuentaContable}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2} style={{ textAlign: "center" }}>
                                            <FormItem
                                              noStyle
                                              name="generarCuentaDeudorId"
                                              valuePropName="checked"
                                            >
                                              <Checkbox
                                                disabled={
                                                  !tipoDeProveedor?.generarCuentasAutomatico ||
                                                  !!this.state?.dataInicial
                                                    ?.cuentaDeudorId
                                                }
                                              ></Checkbox>
                                            </FormItem>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  );
                                }}
                              </FormItem>
                            </DynamicCardForm>
                          </Col>
                          {/* Los selects de arriba siguen bloqueados: editarProveedor
                              borra las cuentas del body y nunca reasigna una ya
                              generada. Mover una cuenta obliga a decidir que pasa con
                              el saldo que se queda en la anterior, y eso vive en el
                              modal. */}
                          {this.state.dataInicial?.tipoProveedorId ? (
                            <Col span={24}>
                              <div style={{ textAlign: "right", marginBottom: 8 }}>
                                <ButtonItem
                                  type="primary"
                                  blanco
                                  size="small"
                                  onClick={() => this.setState({ modalMoverCuentas: true })}
                                >
                                  Mover cuentas contables
                                </ButtonItem>
                              </div>
                            </Col>
                          ) : null}
                        </Row>
                      </>
                    ),
                  },
                  {
                    key: '2',
                    label: 'Dirección',
                    forceRender: true,
                    customContent: (
                      <Row gutter={16}>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <DynamicCardForm title={<span>Ubicación</span>}>
                            <FormItem
                              name="colonia"
                              label="Colonia"
                              margin
                              pattern
                              labelCol={{ span: 4}}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Colonia" />
                            </FormItem>
                            <FormItem
                              label="Colonia"
                              name="coloniaId"
                              margin
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Colonia"
                                onSelect={this.onSelectColoniaId.bind(this)}
                                onSearch={this.onSearchColonia.bind(this)}
                              >
                                {this.state.objetoColonias === null ? (
                                  <Option disabled>Eliga primero un municipio</Option>
                                ) : (
                                  this.state.objetoColonias
                                )}
                                <Option disabled>Busque por codigo postal</Option>
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Municipio"
                              name="municipioId"
                              margin
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Municipio"
                                onChange={this.onChangeMunicipio.bind(this)}
                              >
                                {this.state.objetoMunicipios === null ? (
                                  <Option disabled>Eliga primero un estado</Option>
                                ) : (
                                  this.state.objetoMunicipios
                                )}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Estado"
                              name="estadoId"
                              margin
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                placeholder="Estado"
                                onChange={this.onChangeEstado.bind(this)}
                              >
                                {this.state.objetoEstados}
                              </SelectItem>
                            </FormItem>
                            <FormItem
                              label="Pais"
                              name="paisId"
                              margin
                              labelCol={{ span: 4 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem placeholder="Pais">
                                {this.state.objetoPaises}
                              </SelectItem>
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <DynamicCardForm title={<span>Domicilio</span>}>
                            <FormItem
                              label="Calle"
                              name="calle"
                              max={200}
                              margin
                              pattern
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Calle" />
                            </FormItem>
                            <FormItem
                              label="Numero"
                              name="numeroCalle"
                              margin
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Numero" numeroCalle />
                            </FormItem>
                            <FormItem
                              label="Numero Interior"
                              name="numeroInterior"
                              margin
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <InputItem placeholder="Numero Interior" numeroCalle />
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: '3',
                    label: 'Insumos Relacionados',
                    forceRender: true,
                    customContent: (
                      <Row gutter={16}>
                        <Col span={24}>
                          <DynamicCardForm
                            title={
                              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                Insumos Relacionados
                                {this.state.insumosRelacionados.length > 0 && (
                                  <span style={{
                                    background: "#00BFD6",
                                    color: "white",
                                    borderRadius: 10,
                                    padding: "1px 8px",
                                    fontSize: 11,
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                  }}>
                                    {this.state.insumosRelacionados.length}
                                  </span>
                                )}
                              </span>
                            }
                          >
                            {this.state.insumosRelacionados.length === 0 ? (
                              <div style={{
                                textAlign: "center",
                                padding: "48px 24px",
                                color: "#bbb",
                              }}>
                                <div style={{ fontSize: 40, marginBottom: 12 }}>📦</div>
                                <p style={{ fontSize: 14, margin: 0 }}>No existe ninguna relación todavía</p>
                              </div>
                            ) : (
                              <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid #e8e8e8" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                  <thead>
                                    <tr style={{ background: "#00BFD6" }}>
                                      {[
                                        { label: "Código", w: "10%", align: "center" },
                                        { label: "Cód. Proveedor", w: "10%", align: "center" },
                                        { label: "Descripción", w: "17%", align: "left" },
                                        { label: "Desc. Proveedor", w: "17%", align: "left" },
                                        { label: "Unidad", w: "9%", align: "center" },
                                        { label: "Conversión", w: "9%", align: "center" },
                                        { label: "Compra Mín.", w: "9%", align: "center" },
                                        { label: "Costo", w: "9%", align: "right" },
                                        { label: "Costo Unit.", w: "10%", align: "right" },
                                      ].map((col) => (
                                        <th key={col.label} style={{
                                          width: col.w,
                                          textAlign: col.align,
                                          padding: "10px 12px",
                                          color: "white",
                                          fontWeight: 600,
                                          letterSpacing: "0.3px",
                                          borderBottom: "none",
                                          whiteSpace: "nowrap",
                                        }}>
                                          {col.label}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.insumosRelacionados.map((ir, idx) => (
                                      <tr
                                        key={idx}
                                        style={{
                                          background: idx % 2 === 0 ? "white" : "rgb(246,250,252)",
                                          transition: "background 0.15s",
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background = "rgba(0,191,214,0.07)"}
                                        onMouseLeave={e => e.currentTarget.style.background = idx % 2 === 0 ? "white" : "rgb(246,250,252)"}
                                      >
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>
                                          <span style={{
                                            display: "inline-block",
                                            background: "#e6f7ff",
                                            color: "#0891a1",
                                            border: "1px solid #b5e8ef",
                                            borderRadius: 4,
                                            padding: "1px 7px",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            fontFamily: "monospace",
                                          }}>
                                            {!ir.codigoInsumo || ir.codigoInsumo === "undefined" ? "—" : ir.codigoInsumo}
                                          </span>
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>
                                          <span style={{
                                            display: "inline-block",
                                            background: "#fff7e6",
                                            color: "#b05e00",
                                            border: "1px solid #ffd591",
                                            borderRadius: 4,
                                            padding: "1px 7px",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            fontFamily: "monospace",
                                          }}>
                                            {!ir.codigo || ir.codigo === "undefined" ? "—" : ir.codigo}
                                          </span>
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", color: "#262626", fontWeight: 500 }}>
                                          {ir.descripcion}
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", color: "#595959" }}>
                                          {ir.descripcionProveedor || <span style={{ color: "#ccc" }}>—</span>}
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>
                                          <span style={{
                                            background: "#f6ffed",
                                            color: "#389e0d",
                                            border: "1px solid #b7eb8f",
                                            borderRadius: 10,
                                            padding: "1px 8px",
                                            fontSize: 12,
                                          }}>
                                            {ir.unidadInformativa || ir.claveUnidad || "—"}
                                          </span>
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "center", color: "#595959" }}>
                                          {ir.conversion || 1}
                                          <AyudaConversion insumo={{ _id: ir._id, conversion: ir.conversion || 1 }} />
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "center", color: "#595959" }}>
                                          {ir.compraMin || <span style={{ color: "#ccc" }}>—</span>}
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "right", fontWeight: 500, color: "#262626" }}>
                                          {dineroDisabledMask(ir.costo || 0)}
                                        </td>
                                        <td style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", textAlign: "right", fontWeight: 600, color: "#00919e" }}>
                                          {dineroDisabledMask((ir.costo || 0) / (ir.conversion || 1))}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    key: '4',
                    label: 'Subir productos',
                    forceRender: true,
                    customContent: (
                      <Spin spinning={this.state.loadingSubir}>
                        <Row gutter={16}>
                          <Col span={24}>
                            <DynamicCardForm title={<span>Subir Productos del Proveedor</span>}>
                              <div
                                style={{
                                  border: "1px dashed #d9d9d9",
                                  backgroundColor: "#fafafa",
                                  borderRadius: 6,
                                  padding: 16,
                                  marginTop: 10,
                                  marginBottom: 10,
                                }}
                              >
                                <Row>
                                  <Col
                                    span={12}
                                    style={{ display: "flex", justifyContent: "center" }}
                                  >
                                    <ButtonItem icon={<DownloadOutlined />} href={plantilla} type="primary" verde>
                                      Descargar Plantilla
                                    </ButtonItem>
                                  </Col>
                                  <Col
                                    span={12}
                                    style={{ display: "flex", justifyContent: "center" }}
                                  >
                                    <Upload
                                      showUploadList={{
                                        showRemoveIcon: false,
                                        showPreviewIcon: false,
                                      }}
                                      fileList={this.state.archivosExcel}
                                      customRequest={this.onChangeArchivo.bind(this)}
                                      accept=".xlsx"
                                      maxCount={this.state.maximoArchivos}
                                    >
                                      <ButtonItem icon={<UploadOutlined />} cyan>
                                        Subir Archivo
                                      </ButtonItem>
                                    </Upload>
                                  </Col>
                                </Row>
                              </div>
                              <FormInitial.List name="insumosSubir">
                                {(fields, { remove }) => (
                                  fields.length > 0 ? (
                                  <>
                                  <div className="tabla-insumos-venta" style={{ overflowX: "auto",marginTop: 30 }}>
                                    <table
                                      className="table table-12px"
                                      style={{ width: "100%", backgroundColor: "white" }}
                                    >
                                      {fields.length > 0 ? (
                                        <thead>
                                          <tr>
                                            <th className="th-border" style={{ width: "10%" }}>
                                              Codigo
                                            </th>
                                            <th className="th-border" style={{ width: "30%" }}>
                                              Descripcion
                                            </th>
                                            <th className="th-border" style={{ width: "20%" }}>
                                              Insumo
                                            </th>
                                            <th className="th-border" style={{ width: "7%" }}>
                                              Unidad
                                            </th>
                                            <th className="th-border" style={{ width: "7%" }}>
                                              Compra Min.
                                            </th>
                                            <th className="th-border" style={{ width: "7%" }}>
                                              Conversion
                                            </th>
                                            <th className="th-border" style={{ width: "12%" }}>
                                              Precio
                                            </th>
                                            <th
                                              className="th-border-sin-right"
                                              style={{ width: "7%" }}
                                            >
                                              Eliminar
                                            </th>
                                          </tr>
                                        </thead>
                                      ) : null}
                                      {fields.length > 0
                                        ? fields.map(
                                            (
                                              { key, name, fieldKey, ...restField },
                                              arrayKey,
                                            ) => (
                                              <tbody key={arrayKey}>
                                                <tr>
                                                  <td className="td-border">
                                                    <FormItem
                                                      name={[name, "codigo"]}
                                                      fieldKey={[arrayKey, "codigo"]}
                                                      noStyle
                                                    >
                                                      <InputItem
                                                        disabled
                                                        sinBorde
                                                        placeholder="Código"
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "descripcion"]}
                                                      fieldKey={[arrayKey, "descripcion"]}
                                                      noStyle
                                                    >
                                                      <InputItem
                                                        disabled
                                                        sinBorde
                                                        placeholder="Descripción"
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "insumoId"]}
                                                      fieldKey={[arrayKey, "insumoId"]}
                                                      noStyle
                                                    >
                                                      <SelectInsumosItem
                                                        empresaId={this.props.empresaId}
                                                        headersToken={
                                                          this.props.headersToken
                                                        }
                                                        sinBorde
                                                        autoFocus
                                                        dropdownMatchSelectWidth={600}
                                                        width="100%"
                                                        placeholder="Insumo"
                                                        tiposInsumos="compra"
                                                        insumoPreCargado={this.insumoPreCargadoSubir(name)}
                                                        cargarAlAbrir
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "unidadInformativa"]}
                                                      fieldKey={[
                                                        arrayKey,
                                                        "unidadInformativa",
                                                      ]}
                                                      noStyle
                                                    >
                                                      <InputItem
                                                        disabled
                                                        sinBorde
                                                        placeholder="Unidad"
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "compraMin"]}
                                                      fieldKey={[arrayKey, "compraMin"]}
                                                      noStyle
                                                      numberCero
                                                    >
                                                      <InputNumberItem
                                                        sinBorde
                                                        placeholder="Compra Min"
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "conversion"]}
                                                      fieldKey={[arrayKey, "conversion"]}
                                                      noStyle
                                                      numberCero
                                                    >
                                                      <InputNumberItem
                                                        sinBorde
                                                        placeholder="Conversion"
                                                      />
                                                    </FormItem>
                                                    <FormItem
                                                      shouldUpdate={(prev, curr) =>
                                                        prev.insumosSubir?.[arrayKey]?.conversion !==
                                                        curr.insumosSubir?.[arrayKey]?.conversion
                                                      }
                                                      noStyle
                                                    >
                                                      {({ getFieldValue }) => (
                                                        <AyudaConversion
                                                          insumo={{
                                                            conversion: getFieldValue([
                                                              "insumosSubir",
                                                              arrayKey,
                                                              "conversion",
                                                            ]),
                                                          }}
                                                        />
                                                      )}
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border">
                                                    <FormItem
                                                      {...restField}
                                                      name={[name, "precio"]}
                                                      fieldKey={[arrayKey, "precio"]}
                                                      noStyle
                                                    >
                                                      <InputNumberItem
                                                        dinero
                                                        sinBorde
                                                        placeholder="Precio"
                                                      />
                                                    </FormItem>
                                                  </td>
                                                  <td className="td-border" style={{ textAlign: "center" }}>
                                                    <FormItem noStyle>
                                                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <ButtonItem
                                                          type="dashed"
                                                          onClick={() => remove(name)}
                                                          rojo2
                                                          className="action-buttons"
                                                          icon={<DeleteOutlined />}
                                                        >
                                                        </ButtonItem>
                                                      </div>
                                                    </FormItem>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            ),
                                          )
                                        : null}
                                    </table>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Popconfirm
                                      title={
                                        "Seguro que quieres subir estos productos, se generaran nuevas relaciones si no existen"
                                      }
                                      onConfirm={() => this.subirProductos()}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <ButtonItem
                                        type="primary"
                                        blanco
                                        style={{ margin: "20px 0px 10px 0" }}
                                      >
                                        Subir Productos
                                      </ButtonItem>
                                    </Popconfirm>
                                  </div>
                                  </>
                                 ) : null
                                )}
                              </FormInitial.List>

                           
                            </DynamicCardForm>
                          </Col>
                        </Row>
                      </Spin>
                    ),
                  },
                  {
                    key: '5',
                    label: 'Complementos',
                    forceRender: true,
                    customContent: (
                      <Row gutter={16}>
                        <Col span={12} xs={24} sm={24} lg={8} xl={8}>
                          {this.state.factorajeFinancieroCXC ? (
                            <DynamicCardForm title={<span>Factoraje Financiero</span>}>
                              <FormItem
                                label="Activar Factoraje Financiero"
                                name="factorajeFinancieroCXC"
                                margin
                                valuePropName="checked"
                                tooltip="Al activar esta casilla se activa el factoraje financiero para este proveedor."
                                labelCol={{ span: 14 }}
                                wrapperCol={{ span: 10 }}
                              >
                                <SwitchItem />
                              </FormItem>
                            </DynamicCardForm>
                          ) : null}
                        </Col>
                        <Col span={17} xs={24} sm={24} lg={16} xl={16}>
                          <DynamicCardForm title={<span>Configuración Dropshipping</span>}>
                            <FormItem
                              label="¿Es proveedor Dropshipping?"
                              name="esDropshipping"
                              valuePropName="checked"
                              margin
                              labelCol={{ lg: { span: 6}, xl: { span: 6}, sm: { span: 14 }, xs: { span: 14 } }} 
                              wrapperCol={{ span: 12 }}
                            >
                              <SwitchItem />
                            </FormItem>

                            <FormItem
                              shouldUpdate={(prev, curr) =>
                                prev.esDropshipping !== curr.esDropshipping
                              }
                              noStyle
                            >
                              {({ getFieldValue }) =>
                                getFieldValue("esDropshipping") && (
                                  <>
                                    <FormItem
                                      label="Empresa Dropshipping"
                                      name="empresaDropshipping"
                                      required
                                      margin
                                      labelCol={{ span: 6 }}
                                      wrapperCol={{ span: 16 }}
                                    >
                                      <SelectItem placeholder="Seleccionar Empresa">
                                        <Option value="URREA">URREA</Option>
                                      </SelectItem>
                                    </FormItem>

                                    <Row gutter={16}>
                                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                        <FormItem
                                          label="Código Postal"
                                          name={["direccionDropshipping", "coloniaId"]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            placeholder="CP"
                                            onSearch={this.onSearchColoniaDropshipping.bind(
                                              this,
                                            )}
                                            onSelect={this.onSelectColoniaIdDropshipping.bind(
                                              this,
                                            )}
                                          >
                                            {this.state.objetoColoniasDropshipping || (
                                              <Option disabled>Busque por CP</Option>
                                            )}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Municipio"
                                          name={[
                                            "direccionDropshipping",
                                            "municipioId",
                                          ]}
                                          margin
                                            labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            onChange={this.onChangeMunicipioDropshipping.bind(
                                              this,
                                            )}
                                            placeholder="Municipio"
                                          >
                                            {this.state
                                              .objetoMunicipiosDropshipping || (
                                              <Option disabled>Elija un estado</Option>
                                            )}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Estado"
                                          name={["direccionDropshipping", "estadoId"]}
                                          margin
                                          labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem
                                            onChange={this.onChangeEstadoDropshipping.bind(
                                              this,
                                            )}
                                            placeholder="Estado"
                                          >
                                            {this.state.objetoEstados}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Pais"
                                          name={["direccionDropshipping", "paisId"]}
                                          margin
                                            labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <SelectItem placeholder="Pais">
                                            {this.state.objetoPaises}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem
                                          label="Colonia"
                                          name={["direccionDropshipping", "colonia"]}
                                          margin
                                          pattern
                                           labelCol={{ lg: { span: 12}, xl: { span: 12}, xs: { span: 6 } }} 
                                          wrapperCol={{ span: 12 }}
                                        >
                                          <InputItem placeholder="Colonia" />
                                        </FormItem>
                                      </Col>
                                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                                        <FormItem
                                          label="Calle"
                                          name={["direccionDropshipping", "calle"]}
                                          margin
                                          pattern
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Calle" />
                                        </FormItem>
                                        <FormItem
                                          label="Número"
                                          name={[
                                            "direccionDropshipping",
                                            "numeroCalle",
                                          ]}
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem
                                            placeholder="Num. Ext"
                                            numeroCalle
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Num. Int"
                                          name={[
                                            "direccionDropshipping",
                                            "numeroInterior",
                                          ]}
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem
                                            placeholder="Num. Int"
                                            numeroCalle
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Correo"
                                          name={["direccionDropshipping", "correo"]}
                                          margin
                                          pattern
                                          email
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputItem placeholder="Correo dropshipping" />
                                        </FormItem>
                                        <FormItem
                                          label="Teléfono"
                                          name={["direccionDropshipping", "telefono"]}
                                          margin
                                          labelCol={{ span: 6 }}
                                          wrapperCol={{ span: 14 }}
                                        >
                                          <InputNumberItem
                                            placeholder="Teléfono"
                                            celular
                                          />
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </>
                                )
                              }
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  ...(this.props.consultarProveedoresOnline
                    ? [
                        {
                          key: '7',
                          label: 'Acceso a Catálogo',
                          forceRender: true,
                          customContent: (
                            <Row gutter={16}>
                              <Col span={24} xs={24} sm={24} lg={12} xl={12}>
                                <DynamicCardForm title={<span>Acceso a Catálogo</span>}>
                                  {this.state.credencialesConfiguradas && (
                                    <div
                                      style={{
                                        color: "#52c41a",
                                        marginBottom: 8,
                                        fontWeight: 500,
                                      }}
                                    >
                                      Credenciales configuradas ✓
                                    </div>
                                  )}
                                  <FormItem
                                    label="Tipo"
                                    name={["credencialesProveedor", "tipo"]}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <SelectItem placeholder="Tipo de catálogo" allowClear>
                                      <Option value="levic">Levic</Option>
                                      <Option value="nadro">Nadro</Option>
                                      <Option value="rosario">Rosario</Option>
                                    </SelectItem>
                                  </FormItem>
                                  <FormItem
                                    label="Usuario"
                                    name={["credencialesProveedor", "usuario"]}
                                    margin
                                    max={100}
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <InputItem placeholder="Usuario del catálogo" />
                                  </FormItem>
                                  <FormItem
                                    label="Contraseña"
                                    name={["credencialesProveedor", "password"]}
                                    margin
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ lg: { span: 17 }, xl: { span: 17 }, xs: { span: 18 } }}
                                  >
                                    <Input.Password
                                      placeholder={
                                        this.state.credencialesConfiguradas
                                          ? "Dejar vacío para no cambiar"
                                          : "Contraseña"
                                      }
                                      autoComplete="new-password"
                                    />
                                  </FormItem>
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []),
                  {
                    key: '6',
                    label: 'Archivos',
                    customContent: (
                      <Row gutter={16}>
                        <Col span={24}>
                          <DynamicCardForm title={<span>Archivos del Proveedor</span>}>
                            <FormItem
                              name="archivos"
                              margin
                              style={{
                                display: "block",
                                justifyContent: "flex-start",
                                alignItems: "initial",
                                textAlign: "left",
                              }}
                            >
                              <Upload
                                showUploadList={{
                                  showRemoveIcon: true,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="¿Seguro que quieres eliminar el archivo?"
                                      onConfirm={() => {
                                        this.onRemoveFile(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined
                                        onClick={(e) => e.preventDefault()}
                                      />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosProveedor}
                                customRequest={this.customRequestArchivos.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                                beforeUpload={this.beforeUploadArchivos}
                              >
                                <ButtonItem
                                  icon={<UploadOutlined />}
                                  style={{ padding: "0px 45px" }}
                                  cyan
                                  disabled={
                                    this.state.archivosProveedor.length >=
                                    this.state.maximoArchivos
                                  }
                                >
                                  Agregar archivos
                                </ButtonItem>
                              </Upload>
                            </FormItem>
                          </DynamicCardForm>
                        </Col>
                      </Row>
                    ),
                  },
                  ...(this.props.evaluacionProveedores && this.props.permisoAccesoEvaluacionProveedores
                    ? [
                        {
                          key: '8',
                          label: 'Evaluación de Proveedores',
                          customContent: (
                            <Row gutter={16}>
                              <Col span={24}>
                                <DynamicCardForm title={<span>Programación de Evaluaciones</span>}>
                                  <ProgramacionEvaluacionesProveedor proveedorId={this.state.id} />
                                </DynamicCardForm>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []),
                ]}
              />
            </Form>
          </Spin>
        </div>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this,
          )}
        />
        <ModalPrevisualizarArchivos
          file={currentPreviewFile}
          proveedorId={this.state.id}
          visible={filePreviewVisible}
          onClose={this.handleCloseFilePreview}
        />
        <CambiarTipoEntidadModal
          visible={this.state.modalCambiarTipo}
          entidad="proveedor"
          entidadId={this.state.id}
          nombre={this.state.dataInicial?.persona
            ? this.state.dataInicial?.razonSocial
            : [
                this.state.dataInicial?.nombre,
                this.state.dataInicial?.apellidoPaterno,
                this.state.dataInicial?.apellidoMaterno,
              ]
                .filter(Boolean)
                .join(" ")}
          tipos={this.state.todasTipoDeProveedor}
          tipoActualId={this.state.dataInicial?.tipoProveedorId}
          onCerrar={(huboCambio, resultado) => {
            this.setState({
              modalCambiarTipo: false,
              polizaReclasificacionId: resultado?.polizaId || null,
            });
            // El tipo cambia cuentas contables y puede generar subcuentas nuevas:
            // se recarga todo para que el formulario no quede con datos viejos.
            if (huboCambio) this.consultarTodo();
          }}
        />
        <MoverCuentasEntidadModal
          visible={this.state.modalMoverCuentas}
          entidad="proveedor"
          entidadId={this.state.id}
          nombre={this.state.dataInicial?.persona
            ? this.state.dataInicial?.razonSocial
            : [
                this.state.dataInicial?.nombre,
                this.state.dataInicial?.apellidoPaterno,
                this.state.dataInicial?.apellidoMaterno,
              ]
                .filter(Boolean)
                .join(" ")}
          cuentasContables={this.state.todasCuentaContable}
          onCerrar={(huboCambio, resultado) => {
            this.setState({
              modalMoverCuentas: false,
              polizaReclasificacionId: resultado?.polizaId || null,
            });
            // Las cuentas del formulario se leen del proveedor: hay que recargarlo.
            if (huboCambio) this.consultarTodo();
          }}
        />
        <ModalEditarPoliza
          visible={!!this.state.polizaReclasificacionId}
          polizaId={this.state.polizaReclasificacionId}
          onCancel={() => this.setState({ polizaReclasificacionId: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    consultarProveedoresOnline: state.empresa.consultarProveedoresOnline,
    escuela: state.empresa.escuela,
    evaluacionProveedores: state.empresa.evaluacionProveedores,
    permisoAccesoEvaluacionProveedores:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (v) => v.permisoId.toString() === "6a726d2e84bfe1e26a3e4c65",
      )?.activado,
  };
};

export default connect(mapStateToProps)(EditarProveedor);
